import { Star, MapPin } from "lucide-react";

const CREATORS = [
  { id: 1, name: "Maya H.", handle: "@mayahassoun", location: "Dubai", rating: 4.9, image_url: "https://images.unsplash.com/photo-1544005313-94ddf0286df2?w=400&q=80" },
  { id: 2, name: "Sofia L.", handle: "@sofialev", location: "Riyadh", rating: 4.8, image_url: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=400&q=80" },
  { id: 3, name: "Imani O.", handle: "@imanio", location: "Dubai", rating: 5.0, image_url: "https://images.unsplash.com/photo-1488426862026-3ee34a7d66df?w=400&q=80" },
  { id: 4, name: "Layla K.", handle: "@laylak", location: "Doha", rating: 4.7, image_url: "https://images.unsplash.com/photo-1531746020798-e6953c6e8e04?w=400&q=80" },
  { id: 5, name: "Nour A.", handle: "@noura", location: "Abu Dhabi", rating: 4.9, image_url: "https://images.unsplash.com/photo-1524504388940-b1c1722653e1?w=400&q=80" },
  { id: 6, name: "Reem S.", handle: "@reems", location: "Karachi", rating: 4.8, image_url: "https://images.unsplash.com/photo-1586297135537-94bc81ba6e5e?w=400&q=80" },
];

export default function Creators() {
  return (
    <section id="creators" data-testid="creators-section" className="py-24 sm:py-32 bg-[#FFFFFF]">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid lg:grid-cols-12 gap-12 mb-14">
          <div className="lg:col-span-7">
            <p className="text-xs uppercase tracking-[0.22em] text-[#276152] font-semibold">The roster</p>
            <h2 className="font-serif text-5xl sm:text-6xl leading-[0.95] mt-4 text-[#0D3A35]">Curated, not crowdsourced.</h2>
          </div>
          <div className="lg:col-span-5 self-end">
            <p className="text-lg leading-relaxed text-[#0D3A35]/75">
              Every creator on Lychee is hand-reviewed for craft, reliability, and aesthetic fit. We turn down 9 of every 10 applicants — you'll never see them.
            </p>
          </div>
        </div>

        <div data-testid="creators-grid" className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4">
          {CREATORS.map((c, i) => (
            <article
              key={c.id}
              data-testid={`creator-card-${c.id}`}
              className={`group relative rounded-xl overflow-hidden border border-[#B1B7AB]/40 bg-white ${i % 3 === 1 ? "md:translate-y-8" : ""}`}
            >
              <div className="aspect-[3/4] bg-[#B1B7AB]/30 overflow-hidden">
                <img src={c.image_url} alt={c.name} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" />
              </div>
              <div className="absolute inset-x-0 bottom-0 p-3 bg-gradient-to-t from-[#0D3A35]/95 via-[#0D3A35]/60 to-transparent">
                <p className="text-[#FFFFFF] text-sm font-medium leading-tight">{c.name}</p>
                <p className="text-[#B1B7AB] text-[11px]">{c.handle}</p>
                <div className="mt-2 flex items-center justify-between text-[10px] text-[#FFFFFF]/85">
                  <span className="inline-flex items-center gap-1"><MapPin className="w-3 h-3" strokeWidth={2} />{c.location}</span>
                  <span className="inline-flex items-center gap-1"><Star className="w-3 h-3 fill-[#FFFFFF]" strokeWidth={0} />{c.rating.toFixed(1)}</span>
                </div>
              </div>
            </article>
          ))}
        </div>
        <p className="mt-10 text-sm text-[#276152]/85">+ 200 on-ground creators across MENA and South Asia. Visible after booking.</p>
      </div>
    </section>
  );
}
